function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "white",
  fillOpacity: 0.85
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 27.5,
  stroke: "#E5E5E5",
  strokeOpacity: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6254 31.4749C20.2254 31.4749 19.8796 31.3291 19.5879 31.0374C19.2962 30.7457 19.1504 30.3999 19.1504 29.9999C19.1504 29.5832 19.2962 29.2332 19.5879 28.9499C19.8796 28.6666 20.2254 28.5249 20.6254 28.5249C21.0254 28.5249 21.3754 28.6666 21.6754 28.9499C21.9754 29.2332 22.1254 29.5749 22.1254 29.9749C22.1254 30.3916 21.9754 30.7457 21.6754 31.0374C21.3754 31.3291 21.0254 31.4749 20.6254 31.4749ZM28.0254 31.4749C27.6087 31.4749 27.2546 31.3291 26.9629 31.0374C26.6712 30.7457 26.5254 30.3999 26.5254 29.9999C26.5254 29.5832 26.6712 29.2332 26.9629 28.9499C27.2546 28.6666 27.6004 28.5249 28.0004 28.5249C28.4171 28.5249 28.7671 28.6666 29.0504 28.9499C29.3337 29.2332 29.4754 29.5749 29.4754 29.9749C29.4754 30.3916 29.3337 30.7457 29.0504 31.0374C28.7671 31.3291 28.4254 31.4749 28.0254 31.4749ZM35.3754 31.4749C34.9587 31.4749 34.6046 31.3291 34.3129 31.0374C34.0212 30.7457 33.8754 30.3999 33.8754 29.9999C33.8754 29.5832 34.0212 29.2332 34.3129 28.9499C34.6046 28.6666 34.9587 28.5249 35.3754 28.5249C35.7921 28.5249 36.1462 28.6666 36.4379 28.9499C36.7296 29.2332 36.8754 29.5749 36.8754 29.9749C36.8754 30.3916 36.7296 30.7457 36.4379 31.0374C36.1462 31.3291 35.7921 31.4749 35.3754 31.4749Z",
  fill: "black",
  fillOpacity: 0.65
});

function SvgButtonZoomSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonZoomSvg);
export default __webpack_public_path__ + "static/media/buttonZoomSvg.a9fb53df.svg";
export { ForwardRef as ReactComponent };